module.exports = __webpack_public_path__ + "static/media/start-blood-badge.34c3d895.svg";